export const AttachmentsEndpoint = {
    order: `${process.env.API_BACKEND}/v1/order_attachments/order`,
    archive: `${process.env.API_BACKEND}/v1/order_attachments/order/archive`,
    attachment: `${process.env.API_BACKEND}/v1/order_attachments/order/attachment`,
} as const
